import { Http } from '../../http'

export class FavoriteButton {
  constructor (elm, addFavoritePath) {
    this.elm = elm;
    this.addFavoritePath = addFavoritePath;
    this.postId = elm.dataset.postId;

    this.elm.addEventListener('click', e => {
      this.onFavoriteClick();
    }, false)
  }

  onFavoriteClick () {
    if (this.elm.dataset.isLiked === 'true') {
      Http.post(`${ this.addFavoritePath }/${ this.postId }`, {}, 'DELETE')
        .then(response => {
          this.elm.dataset.isLiked = 'false';
        })
    } else {
      Http.post(this.addFavoritePath, { post_id: this.postId })
        .then(response => {
          this.elm.dataset.isLiked = 'true';
        })
    }
  }
}
